import type { AttributeTypeKey } from 'BlockList/types';

// Gate dash-strip on phone only — drivers_license and name_dob carry
// semantic dashes/separators in their stored form.
export const normalizeSearchQuery = (
  q: string,
  attributeType: AttributeTypeKey | ''
): string => {
  if (attributeType === 'phone_number') {
    return q.replace(/-/g, '');
  }
  return q;
};
